export default __webpack_public_path__ + "ab777e42db52171578ca794f703a7534.png";